import { Component, Input, forwardRef, Output, EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { SelectedTag } from '../ngrx/actions';
import { State } from '../ngrx/reducers';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'tags-select',
  templateUrl: './tags-select.component.html',
  styleUrls: ['./tags-select.component.scss'],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => TagsSelectComponent), multi: true }
  ]
})
export class TagsSelectComponent implements ControlValueAccessor {
    @Input() title : string;
    @Input() tags : Observable<any[]>;
    @Input() type : string;
    @Output() ngModelChange = new EventEmitter<any>();
    private innerValue;
    private onChangeCallback: (_: any) => void;

    constructor (private store: Store<State>) {
    }

    selected () {
      this.store.dispatch(new SelectedTag({type : this.type , value : this.innerValue}));
    }

    get value () {
      return this.innerValue;
    }
  
    set value (data: any) {
      if (this.innerValue !== data) {
        this.innerValue = data;
      }
  
      if (this.onChangeCallback) {
        this.onChangeCallback(this.innerValue);
      }
    }

    registerOnChange (fn: any) {
      this.onChangeCallback = fn;
    }
  
    registerOnTouched (fn: any) {
    }
  
    setDisabledState (isDisabled: boolean) {
    }
  
    writeValue (data: any) {
      if (this.innerValue !== data) {
        this.innerValue = data;
      }
    }
}
